"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
/**
 * Maybe: https://gist.github.com/madou/0de18176fc30c26767e2705f0f5281ef ?
 // eslint-disable-next-line @typescript-eslint/ban-types
 function DefaultPropsHoC<P extends Record<string, unknown>, DP extends Partial<P>>(
 Component: React.ComponentType<P>, defaultProps: DP,
 ): React.FC<Omit<P, keyof DP> & Partial<DP>> {
  return (props) => {
    const allProps = { ...defaultProps, ...props } as P;
    return <Component {...allProps} />;
  };
}
 */
function DefaultPropsHoC(Component, defaultProps, forwardRef) {
    return (forwardRef
        ? react_1.default.forwardRef(function (props, ref) { return (0, jsx_runtime_1.jsx)(Component, __assign({}, defaultProps, props, { ref: ref })); })
        : function (props) { return (0, jsx_runtime_1.jsx)(Component, __assign({}, defaultProps, props)); });
}
exports.default = DefaultPropsHoC;
